"use strict";
import Pusher from "pusher-js";
import { channelAuthorizationWithCsrf } from "../pusher_csrf";
export function createPusherInstance() {
  return new Pusher(PusherConfig.apiKey, {
    channelAuthorization: channelAuthorizationWithCsrf()
  });
}
